/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_Chart_YtdInputs */

const en_us2_stats_chart_ytd = /** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Year to date`)
};

const es_es2_stats_chart_ytd = /** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Año hasta la fecha`)
};

const ru_stats_chart_ytd = /** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`С начала года по настоящее время`)
};

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const id_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const ms_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const da_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const de_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const es_mx2_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const fil_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const fr_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const it_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const hu_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const nl_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const no_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const pl_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const pt_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const pt_br2_stats_chart_ytd = pt_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const ro_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const fi_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const sv_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const vi_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const tr_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const cs_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const bg_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const uk_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const ar_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const hi_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const th_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const ja_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const zh_cn2_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const zh_hant1_stats_chart_ytd = en_us2_stats_chart_ytd;

/** @type {(inputs: Stats_Chart_YtdInputs) => LocalizedString} */
const ko_stats_chart_ytd = en_us2_stats_chart_ytd;

/**
* | output |
* | --- |
* | "Year to date" |
*
* @param {Stats_Chart_YtdInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const stats_chart_ytd = /** @type {((inputs?: Stats_Chart_YtdInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_Chart_YtdInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stats_chart_ytd(inputs)
	if (locale === "ms") return ms_stats_chart_ytd(inputs)
	if (locale === "da") return da_stats_chart_ytd(inputs)
	if (locale === "de") return de_stats_chart_ytd(inputs)
	if (locale === "en-US") return en_us2_stats_chart_ytd(inputs)
	if (locale === "es-ES") return es_es2_stats_chart_ytd(inputs)
	if (locale === "es-MX") return es_mx2_stats_chart_ytd(inputs)
	if (locale === "fil") return fil_stats_chart_ytd(inputs)
	if (locale === "fr") return fr_stats_chart_ytd(inputs)
	if (locale === "it") return it_stats_chart_ytd(inputs)
	if (locale === "hu") return hu_stats_chart_ytd(inputs)
	if (locale === "nl") return nl_stats_chart_ytd(inputs)
	if (locale === "no") return no_stats_chart_ytd(inputs)
	if (locale === "pl") return pl_stats_chart_ytd(inputs)
	if (locale === "pt-BR") return pt_br2_stats_chart_ytd(inputs)
	if (locale === "pt") return pt_stats_chart_ytd(inputs)
	if (locale === "ro") return ro_stats_chart_ytd(inputs)
	if (locale === "fi") return fi_stats_chart_ytd(inputs)
	if (locale === "sv") return sv_stats_chart_ytd(inputs)
	if (locale === "vi") return vi_stats_chart_ytd(inputs)
	if (locale === "tr") return tr_stats_chart_ytd(inputs)
	if (locale === "cs") return cs_stats_chart_ytd(inputs)
	if (locale === "bg") return bg_stats_chart_ytd(inputs)
	if (locale === "ru") return ru_stats_chart_ytd(inputs)
	if (locale === "uk") return uk_stats_chart_ytd(inputs)
	if (locale === "ar") return ar_stats_chart_ytd(inputs)
	if (locale === "hi") return hi_stats_chart_ytd(inputs)
	if (locale === "th") return th_stats_chart_ytd(inputs)
	if (locale === "ja") return ja_stats_chart_ytd(inputs)
	if (locale === "zh-CN") return zh_cn2_stats_chart_ytd(inputs)
	if (locale === "zh-Hant") return zh_hant1_stats_chart_ytd(inputs)
	return ko_stats_chart_ytd(inputs)
});
export { stats_chart_ytd as "stats.chart.ytd" }